import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["qrUrl", "qrUrlField", "canvasTemplate", "articleNotice", "submit", "flipArticle2Field"]
  static values = { articlePresent: Boolean, controlListUrl: String }

  connect() {
    this.pending = false
    this.submitLabel = this.hasSubmitTarget ? this.submitTarget.innerHTML : ""
    this.autoFillQrUrl()
    this.updateState()
  }

  // Auto-fill QR URL field from the associated control list if the field is empty
  autoFillQrUrl() {
    if (this.controlListUrlValue && this.hasQrUrlTarget && !this.qrUrlTarget.value.trim()) {
      this.qrUrlTarget.value = this.controlListUrlValue
    }
  }

  // Reads the visibility flags advertised by the selected template's <option>.
  // Defaults to true (require everything) when no template is selected.
  selectedTemplateFlags() {
    const select = this.canvasTemplateTarget
    const option = select.selectedOptions[0]
    const dataset = option ? option.dataset : {}
    return {
      showQr: dataset.showQr === undefined ? true : dataset.showQr === "true",
      requiresArticle: dataset.requiresArticle === undefined ? true : dataset.requiresArticle === "true",
      showArticle2: dataset.showArticle2 === undefined ? true : dataset.showArticle2 === "true"
    }
  }

  updateState() {
    const { showQr, requiresArticle, showArticle2 } = this.selectedTemplateFlags()

    // Чекбокс разворота артикула 2 имеет смысл только если шаблон рисует артикул 2.
    if (this.hasFlipArticle2FieldTarget) {
      this.flipArticle2FieldTarget.hidden = !showArticle2
    }

    // QR URL: hide the field and drop its requirement when the template has no QR code.
    if (this.hasQrUrlFieldTarget) {
      this.qrUrlFieldTarget.hidden = !showQr
    }
    if (this.hasQrUrlTarget) {
      this.qrUrlTarget.required = showQr
    }

    // Article notice only matters when the template needs an article and it is missing.
    if (this.hasArticleNoticeTarget) {
      this.articleNoticeTarget.hidden = !(requiresArticle && !this.articlePresentValue)
    }

    if (!this.hasSubmitTarget) return

    const articleMissing = requiresArticle && !this.articlePresentValue
    const disabled = this.pending || articleMissing || !this.requiredFieldsPresent(showQr)
    this.submitTarget.disabled = disabled
  }

  async submit(event) {
    event.preventDefault()
    this.updateState()
    if (this.submitTarget.disabled) return

    const form = event.target
    this.pending = true
    this.submitTarget.disabled = true
    this.submitTarget.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Запуск...'

    try {
      const response = await fetch(form.action, {
        method: form.method.toUpperCase(),
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json"
        },
        body: new FormData(form)
      })

      const data = await response.json()
      if (!response.ok || !data.success) {
        throw new Error(data.error || "Не удалось запустить генерацию производственного холста")
      }

      if (window.Toast) {
        window.Toast.fire({ icon: "info", title: data.message })
      }
    } catch (error) {
      alert(`Ошибка: ${error.message}`)
      this.pending = false
      this.submitTarget.innerHTML = this.submitLabel
      this.updateState()
      return
    }

    this.submitTarget.innerHTML = this.submitLabel
  }

  // QR URL is only a required field when the selected template renders a QR code.
  requiredFieldsPresent(showQr) {
    const templatePresent = this.canvasTemplateTarget.value.trim() !== ""
    const qrPresent = !showQr || this.qrUrlTarget.value.trim() !== ""
    return templatePresent && qrPresent
  }
}
